'use strict';

namespace Core {

    interface NewsletterModalUserData {
        Email: string;
        FirstName: string;
        LastName: string;
        Source: string;
        SourceDetail: string;
        SignUpReason: string;
    }
    class NewsletterModal {

        constructor (
            private $scope: ng.IScope,
            private $rootScope : ng.IRootScopeService,
            private modalService,
            private authService,
            private $timeout: ng.ITimeoutService,
            private resourceService: Core.ResourceService,
        ) {}

        private name: string = '';
        private userData: NewsletterModalUserData = {
            Email: '',
            FirstName: '',
            LastName: '',
            Source: this.resourceService.get('NEWSLETTER_MODAL_SOURCE'),
            SourceDetail: this.resourceService.get('NEWSLETTER_MODAL_SOURCE_DETAILS'),
            SignUpReason: this.resourceService.get('NEWSLETTER_MODAL_SIGNUP_REASON'),
        };
        private success: boolean = false;
        private error: boolean = false;
        private isNewsletter: boolean = false;
        private iconUrl = this.resourceService.get('NEWSLETTER_MODAL_ICON_URL');
        private altLogo = this.resourceService.get('NEWSLETTER_MODAL_ALT_LOGO');
        private trustpilotLogo: string = `<img class="trust-pilot-logo" src="${this.iconUrl}"/>`;
        private altBottomLogo: string = this.altLogo !== 'NEWSLETTER_MODAL_ALT_LOGO' ? this.altLogo : '' ;

        private resourcesObj = {
            title:  this.resourceService.get('NEWSLETTER_MODAL_TITLE'),
            subTitle: this.resourceService.get('NEWSLETTER_MODAL_SUBTITLE'),
            policyText:this.resourceService.get('NEWSLETTER_MODAL_POLICYTEXT'),
        };

        private resourcesSuccessObj = {
            title: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_TITLE'),
            subTitle: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_SUBTITLE'),
            subTitle1: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_SUBTITLE1'),
            policyText: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_POLICYTEXT'),
        };

        submit(): void {
            this.formatName();
            this.authService
                .registerForNewsletter(this.userData)
                .success(() => {
                    this.userSubscribed();
                })
            .error(() => {
                this.error = true;
            });
        }

        formatName() {
            const fullName = this.name.split(' ');
            this.userData.FirstName = fullName[0];
            this.userData.LastName = fullName[1] || '';
        };

        userSubscribed() {
            this.success = true;
            this.error = false;
            this.resourcesObj = this.resourcesSuccessObj;
            localStorage.setItem('isAllreadySubscribed', 'true');
        }

        openNewsletter(e?): void {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.isNewsletter = true;
        }

        closeNewsletter(e): void {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            angular.element(document).unbind('scroll');
            this.isNewsletter = false;
            localStorage.setItem('isAllreadySubscribed', 'true');
        }
    }

    angular
        .module('core')
        .directive('newsletterModal', ($timeout): ng.IDirective => {
            return {
                scope: {},
                bindToController: {
                    openOn: '@'
                },
                restrict: 'E',
                replace: true,
                controller: NewsletterModal,
                controllerAs: 'nm',
                templateUrl: 'partials/home/directivetemplate?type=NewsletterModal',
                link: (scope, element, attrs) => {

                    const superHero = $('.sc-c-superhero');
                    const superHeroHeight = superHero ? superHero[0]['clientHeight'] : null;
                    const doc = $(document);

                    if (scope.nm.openOn === 'scroll' && localStorage.getItem('isAllreadySubscribed') !== 'true'
                        && superHeroHeight) {
                        angular.element(document).bind('scroll', function() {
                            if (doc.scrollTop() > superHeroHeight) {
                                scope.nm.openNewsletter();
                            }
                        });
                    } else if (scope.nm.openOn === 'idle' && localStorage.getItem('isAllreadySubscribed') !== 'true') {
                        let idleTime = 0;
                        let idleInterval;

                        idleInterval = setInterval(() => {
                            idleTime = idleTime + 1;
                            if (idleTime > TRPCONFIG.Domain.NewSubscribeModalABtestInactivityTimeout) {
                                scope.nm.isNewsletter = true;
                                scope.$apply();
                                clearInterval(idleInterval);
                            }
                        }, 1000);
                        doc.mousemove((e) => {
                            idleTime = 0;
                        });
                        doc.keypress((e) => {
                            idleTime = 0;
                        });
                    }
                }
            };
        });
}
